import React, { useCallback, useState } from 'react';
import { Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';

import { FormCheckbox, FormTextField } from '@lib/common';
import { ListFilters } from 'app/shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { BillingFrequencies } from 'app/state';

export interface CorporateAccountFilters {
  name?: string;
  billingFrequencyType?: string;
  showAll?: boolean;
  needsReview?: boolean;
}

interface Props {
  filters: CorporateAccountFilters;
  onChange: (filters: CorporateAccountFilters) => void;
}

export const CorporateAccountSearchFilter: React.FC<Props> = ({ filters, onChange }) => {
  const [selectedBillingFrequencyIndex, setSelectedBillingFrequencyIndex] = useState<number>(0);
  const onBillingFrequencyChange = useCallback(
    (index: number) => {
      const { value } = BillingFrequencies[index];
      setSelectedBillingFrequencyIndex(index);
      if (value === 'All') {
        onChange({
          ...filters,
          billingFrequencyType: undefined,
        });
      } else {
        onChange({
          ...filters,
          billingFrequencyType: value,
        });
      }
    },
    [onChange, filters, setSelectedBillingFrequencyIndex]
  );

  return (
    <ListFilters filters={filters} onChange={onChange}>
      <Grid container spacing={2} style={{ padding: '0 1rem 1rem 1rem', marginTop: '1rem' }}>
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <FormTextField
            name="name"
            label="Name"
            fullWidth
            size="small"
            data-testid="corporateAccountNameSearchInput"
          />
        </Grid>
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <InputLabel id="billingFrequencyLabel" style={{ fontSize: '.88em', marginTop: '-.2em' }}>
            Billing Frequency
          </InputLabel>
          <Select
            name="billingFrequencyType"
            labelId="billingFrequencyLabel"
            fullWidth
            onChange={e => onBillingFrequencyChange(Number(e.target.value))}
            value={selectedBillingFrequencyIndex}
            inputProps={{
              IconComponent: (props: any) => (
                <FontAwesomeIcon
                  icon="chevron-down"
                  transform="down-6 left-4"
                  fixedWidth
                  {...props}
                />
              ),
            }}
          >
            {BillingFrequencies.map((x, i) => (
              <MenuItem key={i} value={i} dense>
                <Typography>{x.label}</Typography>
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <FormCheckbox name="showAll" label="Show All" fullWidth />
        </Grid>
      </Grid>
    </ListFilters>
  );
};
